import QuestionsList from "../Questions/QuestionsList";
import AddQuestion from "../../AddQuestion";
import MinCorrectAnswers from "../MinCorrectAnswers";
import { FlexRow } from "src/utils/flexLayouts";
import ButtonAddTestFromRegistry from "../TestsButtons/ButtonAddTestFromRegistry";
import { FC } from "react";
interface IProps {
  zIndex: number;
}
const TestsBody: FC<IProps> = ({ zIndex }) => {
  return (
    <>
      <FlexRow className="flex-col">
        <p className="mb-[10px] font-medium text-lg text-[#637381]">Вопросы</p>
        <div className="flex justify-center flex-col gap-2 pb-5">
          <QuestionsList />
          <AddQuestion />
          <ButtonAddTestFromRegistry zIndex={zIndex} />
          <MinCorrectAnswers />
        </div>
      </FlexRow>
    </>
  );
};
export default TestsBody;
